<!--
 * @Author: wq
 * @Date: 2020-08-31 17:13:37
-->
<template>
    <div class="tabs" v-if="isQrCode" :style="{ width: contentWidth + 'px' }">
        <el-row type="flex" class="tab_row" justify="center">
            <div v-for="(item, index) in tabsData" :key="index" @click="onClickTabs(item, index)"
                :class="tabActive === item.index ? 'router-link-active' : ''" class="btn disabledCopy cursor">{{ item.name }}
            </div>
        </el-row>
    </div>
</template>

<script>
export default {
    name: '',
    props: {
        isQrCode: {
            type: Boolean,
            default: true
        },
        tabsData: {
            type: Array,
            default: []
        },
        tabActive: {
            type: Number,
            default: -1
        },
        contentWidth: {
            type: Number,
            default: 1400
        }
    },
    data() {
        return {}
    },
    components: {},
    created() { },
    computed: {},
    watch: {},
    methods: {
        // 点击tabs
        onClickTabs(item, index) {
            this.$emit('onClickTabs', item)
        },
    }
}
</script>

<style lang='less' scoped>
.tabs {
    max-width: 1440px;
    position: relative;
    margin: 0 auto;
    height: 72px;
    background-color: rgba(24, 75, 175, 0.85);
    border-radius: 6px 6px 0px 0px;
    box-shadow: 0px 2px 8px 1px rgba(0, 0, 0, 0.15);

    .el-row--flex.is-justify-center {
        width: 100%;
        margin: 0 auto;
        height: 72px;
        line-height: 72px;
    }

    .btn {
        flex: 1;
        line-height: 72px;
        font-size: 20px;
        color: #FFFFFF;
        text-align: center;
        cursor: pointer;
        transition: all 0.3s ease;

        &:hover {
            background-color: rgba(255, 255, 255, 0.1);
        }
    }

    .router-link-active {
        background-color: rgba(19, 93, 201, 0.9);
        color: #FFFFFF;
        font-weight: bold;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/indexModule/indexTabs.vue